import React from 'react';
import '../styles/logo.css';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  variant?: 'dark' | 'light';
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true, className = '', variant = 'dark' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className={`${sizeClasses[size]} relative flex items-center justify-center logo-container`}>
        <img 
          src="/images/shetakari-logo.png" 
          alt="Shetkari Agro Fresh Logo" 
          className="w-full h-full object-contain logo-transparent logo-remove-white"
        />
      </div>
      
      {showText && (
        <div className="flex flex-col">
          <h1 className={`font-bold ${variant === 'light' ? 'text-white' : 'text-gray-800'} ${textSizeClasses[size]} leading-tight`}>
            Shetkari Agro Fresh
          </h1>
          {size !== 'sm' && (
            <p className={`text-xs ${variant === 'light' ? 'text-gray-300' : 'text-gray-600'} -mt-1`}>Farm Fresh • Home Delivered</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
